// Table of contents:
// 1 Table
import { Suppliers } from '../../../data'
import { getTranslationsForConfig } from '../getTranslationsForConfig'

export const createSuppliers = (): Suppliers => {
  return {
    // 1 Table
    table: {
      enabled: true,
      title: getTranslationsForConfig('suppliers.table.title'), // t('suppliers.table.title')
      columns: [
        {
          // Id
          dataType: 'string',
          field: 'Id',
          filter: true,
          filterPlaceholder: getTranslationsForConfig(
            'suppliers.table.columns.id.filterPlaceholder',
          ), // t('suppliers.table.columns.id.filterPlaceholder')
          header: getTranslationsForConfig('suppliers.table.columns.id.header'), // t('suppliers.table.columns.id.header')
          sortable: true,
        },
        {
          // Name
          dataType: 'project',
          field: 'Name',
          filter: true,
          header: getTranslationsForConfig(
            'suppliers.table.columns.name.header',
          ), // t('suppliers.table.columns.name.header')
          sortable: true,
        },
        {
          // Description
          dataType: 'string',
          field: 'Description',
          filter: true,
          filterPlaceholder: getTranslationsForConfig(
            'suppliers.table.columns.description.filterPlaceholder',
          ), // t('suppliers.table.columns.description.filterPlaceholder')
          header: getTranslationsForConfig(
            'suppliers.table.columns.description.header',
          ), // t('suppliers.table.columns.description.header')
          sortable: true,
        },
        {
          // Support
          dataType: 'string',
          field: 'Support',
          filter: true,
          filterPlaceholder: getTranslationsForConfig(
            'suppliers.table.columns.support.filterPlaceholder',
          ), // t('suppliers.table.columns.support.filterPlaceholder')
          header: getTranslationsForConfig(
            'suppliers.table.columns.support.header',
          ), // t('suppliers.table.columns.support.header')
          sortable: true,
        },
        {
          // ProcessCompletions for delivery forecasts
          dataType: 'delForProcessIsActive',
          filter: true,
          filterField: 'DelForProcess.Completion',
          header: getTranslationsForConfig(
            'suppliers.table.columns.delForProcessCompletion.header',
          ), // t('suppliers.table.columns.delForProcessCompletion.header')
          sortable: true,
          sortField: 'DelForProcess.Completion',
        },
        {
          // ProcessCompletions for orders
          dataType: 'orderProcessIsActive',
          filter: true,
          filterField: 'OrderProcess.Completion',
          header: getTranslationsForConfig(
            'suppliers.table.columns.orderProcessCompletion.header',
          ), // t('suppliers.table.columns.orderProcessCompletion.header')
          sortable: true,
          sortField: 'OrderProcess.Completion',
        },
        {
          // Status
          dataType: 'active',
          field: 'Status',
          filter: true,
          header: getTranslationsForConfig(
            'suppliers.table.columns.status.header',
          ), // t('suppliers.table.columns.status.header')
          sortable: true,
        },
      ],
      emptyMessageDetails: getTranslationsForConfig(
        'suppliers.table.emptyMessageDetails',
      ), // t('suppliers.table.emptyMessageDetails')
      emptyMessageTitle: getTranslationsForConfig(
        'suppliers.table.emptyMessageTitle',
      ), // t('suppliers.table.emptyMessageTitle')
      paginator: true,
      rows: 20,
      rowsPerPageOptions: [20, 50, 100],
      sortField: 'Id',
      sortOrder: 1,
      scrollHeight: '70vh',
    },
  }
}
